export const f = new Intl.NumberFormat("en-US");
